var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { DivTag, ImgTag } from '../../Utils/AtomicTag';
import { SizeClsMap } from './clsMap';
var Avatar = /** @class */ (function (_super) {
    __extends(Avatar, _super);
    function Avatar(props) {
        return _super.call(this, props) || this;
    }
    Avatar.prototype.render = function () {
        var _a = this.props, className = _a.className, size = _a.size, shape = _a.shape, src = _a.src, icon = _a.icon, children = _a.children, alt = _a.alt, onError = _a.onError;
        var avatarCls = [
            'inline-block',
            'align-middle',
            'text-center',
            'mr-px-10',
            'overflow-hidden',
        ];
        if (shape !== 'square') {
            avatarCls = avatarCls.concat('rounded-full');
        }
        avatarCls = avatarCls.concat(SizeClsMap[size]);
        var childrenToRender;
        if (src) {
            var imgCls = ['w-full', 'h-full'];
            childrenToRender = React.createElement(ImgTag, { atomics: imgCls, src: src, alt: alt, onError: onError });
        }
        else if (icon) {
            childrenToRender = icon;
        }
        else {
            childrenToRender = React.createElement("span", null, children);
        }
        return (React.createElement(DivTag, { name: Avatar.NAME, atomics: avatarCls, className: className }, childrenToRender));
    };
    Avatar.defaultProps = defaultProps;
    Avatar.NAME = 'avatar';
    Avatar.displayName = 'Avatar';
    return Avatar;
}(PureComponent));
export { Avatar };
